import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { NsAlert } from 'components/common/ns-alert/NsAlert';
import {
  setCreditValue,
  selectCreditValue,
  initialState
} from 'state/order-credit/order-summary-slice';

import { useMaskPII } from 'hooks/useMaskPII';
import { usePartner } from 'components/app/routes/usePartner';
import { PARTNERS } from 'config/app-config';
import { NsSelect } from 'components/common/ns-select/NsSelect';

export const testIdVoicesaleWinbackAlert = 'testIdVoicesaleWinbackAlert';

export const CreditOffer = () => {
  const dispatch = useDispatch();

  const { activePartner, creditValues } = usePartner();
  const isVoiceSalesWinbackJourney = activePartner[PARTNERS.VOICESALES_WINBACK];
  const creditAmount = useSelector(selectCreditValue, shallowEqual);
  const { mask } = useMaskPII();
  const creditValuesOptions = creditValues.map((value) => ({ value }));

  const handleCreditChange = (e) => {
    const { value } = e.target;
    const intValue = parseInt(value, 10);
    const newValue = isNaN(intValue) ? initialState.data.creditValue : intValue;

    dispatch(setCreditValue(newValue));
  };

  if (!isVoiceSalesWinbackJourney) {
    return null;
  }
  return (
    <>
      <NsSelect
        name="credit"
        label="Select the value of credit offer to the customer"
        placeholder="Select credit amount"
        onChange={handleCreditChange}
        value={
          creditAmount === initialState.data.creditValue ? '' : creditAmount
        }
        inputAttributes={mask}
        options={creditValuesOptions}
      />
      {creditAmount > 0 && (
        <NsAlert
          heading="Read to the customer before accepting the quote "
          state="info"
          testId={testIdVoicesaleWinbackAlert}
        >
          <p>
            Advise the customer the credit will be added to their account 3
            months after their Start Supply date.
          </p>
          <p>
            The credit will be shown on their statement as Goodwill Credit. This
            will be added to the Electricity account/meter unless the customer
            is Gas Only.
          </p>
          <p>
            The customer has to be a BG customer to receive the credit at the
            time of application. If they leave to another supplier before the 3
            months then they will not receive the credit.
          </p>
        </NsAlert>
      )}
    </>
  );
};
